/**
 * Checks if the current delivery zip is APO/FPO.
 * @returns {boolean} True if the zip code is APO/FPO, false otherwise
 */
export const isAPOFPOZipCode = () => {
  try {
    return typeof window !== 'undefined'
      ? window?.THD_LOCALIZER_AUTO_INIT?.Localizer?.isAPOFPOZipCode?.()
      || false
      : false;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error checking APO/FPO zip code:', error);
    return false;
  }
};
